<template lang='pug'>
.partnerProfile
  .partnerProfile-top
    .partnerProfile-left
      .partnerProfile-image(:style="'background-image: url(' + info.squareThumbnailUrl + ');'")
    .partnerProfile-right
      .partnerProfile-topRight
        .partnerProfile-title {{ info.name }}
        .partnerProfile-subtitle {{ date }}
      .partnerProfile-leftRight
        .partnerProfile-itemGrid
          span.partnerProfile-titleGrid 有效影響力
          span.partnerProfile-subtitleGrid2 {{ info.influence }}
        .partnerProfile-itemGrid
          span.partnerProfile-titleGrid 查核篇數
          span.partnerProfile-subtitleGrid {{ info.totalArticles}}
        .partnerProfile-itemGrid
          span.partnerProfile-titleGrid 擅長分類
          span.partnerProfile-subtitleGrid(v-if="info.category") {{ info.category.join('、') }}
  .partnerProfile-bottom
    p.partnerProfile-paragraph {{ info.description }}
    //- .partnerProfile-seeMore.show--smallScreens ...看更多
</template>
<script>
import { numberWithCommas, getDate } from '@/plugins/tool.js'

export default {
  props: {
    info: Object
  },
  computed: {
    influence() {
      return numberWithCommas(this.info.influence)
    },
    amount() {
      return numberWithCommas(this.info.totalArticles)
    },
    date() {
      if (this.info.createdAt == null)
        return ""
      let date = getDate(this.info.createdAt)
      return date.year + "年" + date.month + "月加入"
    }
  }
}
</script>
